import { render, staticRenderFns } from "./liveBroadcastLandingPageEditing.vue?vue&type=template&id=b1572e2a&scoped=true"
import script from "./liveBroadcastLandingPageEditing.vue?vue&type=script&lang=js"
export * from "./liveBroadcastLandingPageEditing.vue?vue&type=script&lang=js"
import style0 from "./liveBroadcastLandingPageEditing.vue?vue&type=style&index=0&id=b1572e2a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1572e2a",
  null
  
)

export default component.exports